import { useQueryClient } from "@tanstack/react-query";
import { Button } from "../components";

interface QueryErrorProps {
  error: Error;
  queryKeys?: string[][];
}

export function QueryError({ error, queryKeys }: QueryErrorProps) {
  const queryClient = useQueryClient();

  return (
    <div
      style={{
        background: "var(--c-danger-bg, rgba(239,68,68,0.08))",
        border: "1px solid var(--c-danger)",
        borderRadius: 8,
        padding: "16px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
      }}
    >
      <div style={{ color: "var(--c-danger)", fontSize: 14 }}>
        <strong>Failed to load data</strong>
        <span style={{ marginLeft: 8, color: "var(--c-text-secondary)" }}>
          {error.message || "An unexpected error occurred"}
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => {
          if (queryKeys) {
            for (const key of queryKeys) {
              queryClient.invalidateQueries({ queryKey: key });
            }
          } else {
            queryClient.invalidateQueries();
          }
        }}
      >
        Retry
      </Button>
    </div>
  );
}
